"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOutPhysicalGiftCardShippingMethods = exports.filteredOutPhysicalGiftCardShippingMethods = exports.filterOutNonWarehouseShippingMethods = exports.filteredOutNonWarehouseShippingMethods = exports.isHome = exports.isEmail = exports.isInStorePickUp = exports.isCFS = exports.isPudo = void 0;
const isPudo = (name) => name.toLowerCase().includes('pudo');
exports.isPudo = isPudo;
const isCFS = (name) => name.toLowerCase().includes('collect_from_store');
exports.isCFS = isCFS;
const isInStorePickUp = (name) => name.toLowerCase().includes('in_store_pick_up');
exports.isInStorePickUp = isInStorePickUp;
const isEmail = (name) => name.toLowerCase().includes('email');
exports.isEmail = isEmail;
function isHome(name) {
    const lowerName = name.toLowerCase();
    return [exports.isPudo, exports.isCFS, exports.isInStorePickUp, exports.isEmail].every((fn) => !fn(lowerName));
}
exports.isHome = isHome;
exports.filteredOutNonWarehouseShippingMethods = /^(OUTLET_EXPRESS_|EXPRESS_|NEXTDAY_|FEDEX_NEXTDAY_|NEXTDAY_|FEDEX_2DAY_AIR_|2DAY_AIR_)(.*)/;
function filterOutNonWarehouseShippingMethods(shippingMethods) {
    return shippingMethods.filter((shippingMethod) => !exports.filteredOutNonWarehouseShippingMethods.test(shippingMethod.key));
}
exports.filterOutNonWarehouseShippingMethods = filterOutNonWarehouseShippingMethods;
exports.filteredOutPhysicalGiftCardShippingMethods = {
    uk: /^(NEXTDAY_)(.*)/,
    roi: /^(NEXTDAY_|EXPRESS_)(.*)/,
};
function filterOutPhysicalGiftCardShippingMethods(shippingMethods, storeKey) {
    const storeRegex = exports.filteredOutPhysicalGiftCardShippingMethods[storeKey];
    if (!storeRegex)
        return shippingMethods;
    return shippingMethods.filter((shippingMethod) => !storeRegex.test(shippingMethod.key));
}
exports.filterOutPhysicalGiftCardShippingMethods = filterOutPhysicalGiftCardShippingMethods;
//# sourceMappingURL=shippingMethods.js.map